export default {
  en: {
    title: 'Finance',
    myBalance: 'My balance',
    accruals: 'Accruals',
    errorLoad: 'Could not load finances',
    balanceUnavailable: 'Balance temporarily unavailable',
    paginationAria: 'Accruals pagination',
    paginationNext: 'Next pages',
  },
  ru: {
    title: 'Финансы',
    myBalance: 'Мой баланс',
    accruals: 'Начисления',
    errorLoad: 'Не удалось загрузить финансы',
    balanceUnavailable: 'Баланс временно недоступен',
    paginationAria: 'Пагинация начислений',
    paginationNext: 'Следующие страницы',
  },
}
